import { Component, OnInit, Input } from '@angular/core';
import { FormControlComponent } from '../form-control.component';

@Component({
	selector: 'wncm-form-control-slider',
	templateUrl: './form-control-slider.component.html',
	styleUrls: ['../form-control.component.scss', './form-control-slider.component.scss']
})
export class FormControlSliderComponent extends FormControlComponent {
	@Input()
	min: number;

	@Input()
	max: number;

	@Input()
    step: number;
    
    /**
     * Afficher sur le slider la valeur
     */
    @Input()
    showThumb?: boolean = false;

	@Input()
	readOnly: boolean;

	constructor() {
		super();

		if (this.readOnly) {
			this.control.disable();
		}
	}
}
